var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 907,
    height: 459,
    viewBox: "0 0 907 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.16 458.28C703.433 458.28 906.32 449.469 906.32 438.6C906.32 427.731 703.433 418.92 453.16 418.92C202.887 418.92 0 427.731 0 438.6C0 449.469 202.887 458.28 453.16 458.28Z",
    fill: "#B55232"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394.69 143.19L381.29 132.97L261.29 41.48L80.6401 218.85C80.6854 219.007 80.7154 219.167 80.7299 219.33V424.5H554.14L556.26 279.17V273.87L394.69 143.19Z",
    fill: "#E5D3BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.82 281.07V424.5H554.21V278.68L415.82 155.22L274.82 281.07Z",
    fill: "#E5D3BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M572.29 292.43C571.83 292.72 571.288 292.852 570.746 292.805C570.205 292.758 569.693 292.535 569.29 292.17L568.59 291.54L559.15 283.12V424.48H845.88V282.48H588.24L572.29 292.43Z",
    fill: "#E5D3BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.06 43.32H375.29C376.158 43.32 376.991 42.9758 377.606 42.3629C378.221 41.7499 378.567 40.9182 378.57 40.05V39.71C378.567 38.8418 378.221 38.0101 377.606 37.3972C376.991 36.7842 376.158 36.44 375.29 36.44H348.13C347.263 36.44 346.431 36.7845 345.818 37.3978C345.205 38.011 344.86 38.8428 344.86 39.71V40.05C344.86 40.9172 345.205 41.749 345.818 42.3622C346.431 42.9755 347.263 43.32 348.13 43.32H366.06Z",
    fill: "#9EAAB9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.56 48.31H359.86V53.16H363.56V48.31Z",
    fill: "#9EAAB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.56 65.85H359.86V77.25H363.56V65.85Z",
    fill: "#9EAAB9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M366.06 60.85H371.35V58.16H366.06H357.36H352.07V60.85H357.36H366.06Z",
    fill: "#9EAAB9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M582.82 280.04L415.82 131.04L248.82 280.04L260.39 287.22L414.17 150C414.627 149.589 415.22 149.361 415.835 149.361C416.45 149.361 417.043 149.589 417.5 150L571.26 287.22L582.82 280.04Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M262.63 36.19L398.49 139.8L411.95 127.8L261.28 7.33002L185.01 81.5099L43.2599 219.43L61.4699 230.74L259.36 36.43C259.785 36.0027 260.349 35.7431 260.95 35.699C261.551 35.6549 262.148 35.8293 262.63 36.19Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M556.67 429.49H480.17H272.29H213.79H122.31H78.27H68.07V438.6H858.6V429.49H848.41H556.67Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.85 82.25L71.08 185.35L177.08 82.25H109.85Z",
    fill: "#6767C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M362.99 82.2499L417.38 125.73H417.43L484 185.13L444.91 82.1299H362.91L362.99 82.2499Z",
    fill: "#6767C9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480.13 160.8L492.14 192.43L587.53 277.55H872.22L805.74 160.8H480.13Z",
    fill: "#6767C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M413.58 280.75H384.01V321.74H413.58V280.75Z",
    fill: "#85D0EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M413.58 326.75H384.01V367.75H413.58V326.75Z",
    fill: "#85D0EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M448.16 326.75H418.59V367.75H448.16V326.75Z",
    fill: "#85D0EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M448.16 280.75H418.59V321.74H448.16V280.75Z",
    fill: "#85D0EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M753.67 325.39H734.2V351.42H753.67V325.39Z",
    fill: "#85D0EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M753.67 356.42H734.2V382.05H753.67V356.42Z",
    fill: "#85D0EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M776.86 356.42H758.68V382.05H776.86V356.42Z",
    fill: "#85D0EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M776.86 325.39H758.68V351.42H776.86V325.39Z",
    fill: "#85D0EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67 140.33H245.91V157.08H258.67V140.33Z",
    fill: "#85D0EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.43 140.33H263.67V157.08H276.43V140.33Z",
    fill: "#85D0EF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67 118.58H245.91V135.33H258.67V118.58Z",
    fill: "#85D0EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M276.43 118.58H263.67V135.33H276.43V118.58Z",
    fill: "#85D0EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M651.84 325.39H633.66V351.42H651.84V325.39Z",
    fill: "#85D0EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M628.65 325.39H609.18V351.42H628.65V325.39Z",
    fill: "#85D0EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M651.84 356.42H633.66V382.05H651.84V356.42Z",
    fill: "#85D0EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M628.65 356.42H609.18V382.05H628.65V356.42Z",
    fill: "#85D0EF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M676.17 158.59C676.17 158.59 783.92 167.1 810.25 214.09C836.58 261.08 845.9 280.54 845.9 280.54L874.9 279.79L873.32 274.12L807.55 159.43L676.17 158.59Z",
    fill: "#6767C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M411.95 79.68C411.95 79.68 435.19 84.54 442.08 99.53C448.97 114.52 474.49 181.37 474.49 181.37L489.49 193.12L446.95 79.68H411.95Z",
    fill: "#6767C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80.67 235.44L263.67 59.51L386.9 150.14L397.44 143.4L261.17 39.88L78.5 217.14V238.09L80.67 235.44Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M274.59 291.9L415.81 167.41L556.29 289.85V279.17L416.8 153.21L409.44 157.08L271.22 279.44L274.59 291.9Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M137.1 282.54C137.1 282.54 135.31 268.46 140.48 266.54C145.65 264.62 155.63 262.27 155.63 262.27L134.07 259.77V284.18L137.1 282.54Z",
    fill: "#B55232"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M137.1 358.79C137.1 358.79 135.31 344.71 140.48 342.79C145.65 340.87 155.63 338.51 155.63 338.51L134.07 336.02V360.43L137.1 358.79Z",
    fill: "#B55232"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M259.33 292.45V427.15H272.67L271.22 279.44L259.33 292.45Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M442.94 275.75H380.88C377.423 275.75 374.62 278.553 374.62 282.01V369.95C374.62 373.407 377.423 376.21 380.88 376.21H442.94C446.397 376.21 449.2 373.407 449.2 369.95V282.01C449.2 278.553 446.397 275.75 442.94 275.75Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M653.48 320.5H604.95C602.791 320.5 601.04 322.251 601.04 324.41V385.82C601.04 387.979 602.791 389.73 604.95 389.73H653.48C655.639 389.73 657.39 387.979 657.39 385.82V324.41C657.39 322.251 655.639 320.5 653.48 320.5Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M776.82 320.5H730.64C728.481 320.5 726.73 322.251 726.73 324.41V385.82C726.73 387.979 728.481 389.73 730.64 389.73H776.82C778.979 389.73 780.73 387.979 780.73 385.82V324.41C780.73 322.251 778.979 320.5 776.82 320.5Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M278.61 113.58H240.49C238.938 113.58 237.68 114.838 237.68 116.39V162.3C237.68 163.852 238.938 165.11 240.49 165.11H278.61C280.162 165.11 281.42 163.852 281.42 162.3V116.39C281.42 114.838 280.162 113.58 278.61 113.58Z",
    fill: "#E5D3BD"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M552.6 247.43C548.6 248.96 546.36 235.56 541.6 220.02C536.84 204.48 533.95 191.56 535.25 191.16C536.55 190.76 541.49 203.03 546.3 218.57C551.11 234.11 555.67 246.28 552.6 247.43Z",
    fill: "#66142E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M531.04 178.17C530.17 178.44 528.25 174.72 526.75 169.86C525.25 165 524.75 160.86 525.6 160.57C526.45 160.28 528.38 164.03 529.88 168.89C531.38 173.75 531.9 177.91 531.04 178.17Z",
    fill: "#66142E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M571.82 179.25C575.82 177.78 577.97 191.63 582.64 207.74C587.31 223.85 590.05 237.23 588.75 237.6C587.45 237.97 582.6 225.23 577.92 209.11C573.24 192.99 568.71 180.37 571.82 179.25Z",
    fill: "#66142E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M592.82 251.1C593.69 250.85 595.58 254.73 597.05 259.77C598.52 264.81 598.99 269.1 598.12 269.35C597.25 269.6 595.36 265.72 593.9 260.68C592.44 255.64 591.93 251.35 592.82 251.1Z",
    fill: "#66142E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M644.82 265.53C640.95 267.33 637.13 252.11 630.49 234.53C623.85 216.95 619.49 202.24 620.76 201.76C622.03 201.28 628.45 215.18 635.09 232.76C641.73 250.34 647.76 264.14 644.82 265.53Z",
    fill: "#66142E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M615 186.97C614.15 187.29 611.78 183.08 609.7 177.57C607.62 172.06 606.63 167.34 607.47 167.02C608.31 166.7 610.69 170.91 612.77 176.42C614.85 181.93 615.82 186.65 615 186.97Z",
    fill: "#66142E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M641.23 175.11C645.02 173.11 649.23 187.41 656.31 203.78C663.39 220.15 668.13 233.86 666.88 234.4C665.63 234.94 658.88 222.11 651.8 205.73C644.72 189.35 638.32 176.63 641.23 175.11Z",
    fill: "#66142E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M672.96 248.1C673.79 247.74 676.26 251.6 678.48 256.72C680.7 261.84 681.81 266.29 680.98 266.64C680.15 266.99 677.68 263.14 675.47 258.02C673.26 252.9 672.13 248.43 672.96 248.1Z",
    fill: "#66142E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M725.99 268.18C722.32 270.36 716.28 253.74 706.99 234.62C697.7 215.5 691.24 199.5 692.46 198.91C693.68 198.32 702.17 213.35 711.46 232.47C720.75 251.59 728.82 266.5 725.99 268.18Z",
    fill: "#66142E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M684.6 182.91C683.79 183.3 680.78 178.77 677.89 172.79C675 166.81 673.31 161.64 674.13 161.25C674.95 160.86 677.95 165.38 680.84 171.37C683.73 177.36 685.42 182.52 684.6 182.91Z",
    fill: "#66142E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M709.09 164C712.74 161.77 719.09 178.66 728.77 198.1C738.45 217.54 745.26 233.78 744.04 234.38C742.82 234.98 734.04 219.72 724.36 200.29C714.68 180.86 706.28 165.72 709.09 164Z",
    fill: "#66142E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M752.28 250.64C753.09 250.24 756.19 254.84 759.21 260.92C762.23 267 764.02 272.25 763.21 272.66C762.4 273.07 759.3 268.46 756.28 262.38C753.26 256.3 751.47 251.05 752.28 250.64Z",
    fill: "#66142E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M800.76 253.66C797.18 256.01 791.21 241.47 782.08 224.96C772.95 208.45 766.53 194.54 767.72 193.88C768.91 193.22 777.27 206.08 786.39 222.58C795.51 239.08 803.5 251.85 800.76 253.66Z",
    fill: "#66142E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M759.93 180.09C759.14 180.53 756.18 176.7 753.33 171.53C750.48 166.36 748.81 161.83 749.6 161.39C750.39 160.95 753.34 164.79 756.2 169.95C759.06 175.11 760.72 179.65 759.93 180.09Z",
    fill: "#66142E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M789.53 175.43C793.1 173.08 799.13 187.73 808.33 204.37C817.53 221.01 824.01 235.03 822.82 235.68C821.63 236.33 813.21 223.39 804.02 206.75C794.83 190.11 786.82 177.27 789.53 175.43Z",
    fill: "#66142E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M830.67 249.62C831.46 249.18 834.43 253.05 837.3 258.25C840.17 263.45 841.87 268.03 841.08 268.46C840.29 268.89 837.31 265.04 834.44 259.83C831.57 254.62 829.87 250.06 830.67 249.62Z",
    fill: "#66142E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M424.04 103.85C428.04 102.29 429.04 110.73 432.31 120.22C435.58 129.71 437.23 137.75 435.95 138.22C434.67 138.69 430.95 131.34 427.67 121.86C424.39 112.38 420.98 105.05 424.04 103.85Z",
    fill: "#66142E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M391.55 100.86C390.7 101.18 389.12 99.06 388.01 96.11C386.9 93.16 386.69 90.53 387.53 90.21C388.37 89.89 389.96 92.02 391.07 94.96C392.18 97.9 392.39 100.54 391.55 100.86Z",
    fill: "#66142E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M126.21 83.9299C130.31 85.1199 125.31 94.12 121.33 105.69C117.35 117.26 113.08 126.29 111.8 125.85C110.52 125.41 112.7 115.66 116.68 104.09C120.66 92.52 123.06 83.0199 126.21 83.9299Z",
    fill: "#66142E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M108.59 135.62C109.44 135.91 109.13 139.08 107.88 142.7C106.63 146.32 104.94 149.02 104.08 148.7C103.22 148.38 103.54 145.24 104.79 141.62C106.04 138 107.73 135.32 108.59 135.62Z",
    fill: "#66142E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M144.16 104.8C143.27 104.64 142.98 102.01 143.51 98.92C144.04 95.83 145.21 93.45 146.1 93.6C146.99 93.75 147.28 96.39 146.74 99.48C146.2 102.57 145.05 104.95 144.16 104.8Z",
    fill: "#66142E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3 154.08C192.93 153.69 194.72 151.39 197.3 148.93C199.88 146.47 202.3 144.78 202.62 145.17C202.94 145.56 201.21 147.86 198.62 150.32C196.03 152.78 193.67 154.43 193.3 154.08Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M158.08 187.97C157.45 187.31 160.08 183.75 164.01 179.97C167.94 176.19 171.6 173.73 172.23 174.39C172.86 175.05 170.23 178.62 166.3 182.39C162.37 186.16 158.71 188.63 158.08 187.97Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M102.9 240.65C101.8 239.5 110.9 228.98 123.26 217.16C135.62 205.34 146.52 196.7 147.63 197.85C148.74 199 139.63 209.53 127.27 221.35C114.91 233.17 104.01 241.81 102.9 240.65Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M672.73 178.09C672.73 177.55 676.29 177.09 680.73 177.09C685.17 177.09 688.68 177.52 688.68 178.09C688.68 178.66 685.12 179.09 680.73 179.09C676.34 179.09 672.73 178.62 672.73 178.09Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M612.45 178.22C612.45 177.31 617.86 176.57 624.53 176.57C631.2 176.57 636.61 177.31 636.61 178.22C636.61 179.13 631.2 179.88 624.53 179.88C617.86 179.88 612.45 179.14 612.45 178.22Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M556.56 181.04C577.641 181.04 594.73 179.742 594.73 178.14C594.73 176.538 577.641 175.24 556.56 175.24C535.479 175.24 518.39 176.538 518.39 178.14C518.39 179.742 535.479 181.04 556.56 181.04Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M659.24 242.17C659.24 242.7 656.24 243.17 652.53 243.17C648.82 243.17 645.82 242.74 645.82 242.17C645.82 241.6 648.82 241.17 652.53 241.17C656.24 241.17 659.24 241.63 659.24 242.17Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M710.12 242.03C710.12 242.94 705.56 243.68 699.93 243.68C694.3 243.68 689.73 242.94 689.73 242.03C689.73 241.12 694.3 240.37 699.93 240.37C705.56 240.37 710.12 241.11 710.12 242.03Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M757.31 245.01C775.105 245.01 789.53 243.712 789.53 242.11C789.53 240.508 775.105 239.21 757.31 239.21C739.515 239.21 725.09 240.508 725.09 242.11C725.09 243.712 739.515 245.01 757.31 245.01Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M111.61 91.16C111.09 91.02 111.07 89.4701 111.56 87.7201C112.05 85.9701 112.86 84.65 113.37 84.79C113.88 84.93 113.91 86.4701 113.37 88.2301C112.83 89.9901 112.12 91.3 111.61 91.16Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M105.04 115.35C104.16 115.1 104.04 112.74 104.79 110.07C105.54 107.4 106.84 105.43 107.72 105.67C108.6 105.91 108.72 108.28 107.97 110.95C107.22 113.62 105.92 115.59 105.04 115.35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 153.02C92.96 152.59 93.5999 145.4 95.9499 136.95C98.2999 128.5 101.44 121.95 102.95 122.43C104.46 122.91 103.85 130.05 101.5 138.5C99.15 146.95 96.04 153.43 94.5 153.02Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M387.54 322.93C386.69 298.18 392.22 280.06 408.02 280.19V277.55H382.18V323.16L387.54 322.93Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M421.18 322.93C420.32 298.18 425.85 280.06 441.66 280.19V277.55H415.82V323.16L421.18 322.93Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M387.54 369.82C386.69 345.07 392.22 326.95 408.02 327.08V324.43H382.18V370.04L387.54 369.82Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M421.18 369.82C420.32 345.07 425.85 326.95 441.66 327.08V324.43H415.82V370.04L421.18 369.82Z",
    fill: "#85D0EF"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M450.66 372.75H381.51C380.847 372.75 380.211 372.487 379.742 372.018C379.273 371.549 379.01 370.913 379.01 370.25V278.25C379.009 277.921 379.073 277.596 379.198 277.292C379.323 276.988 379.507 276.712 379.739 276.479C379.972 276.247 380.248 276.063 380.552 275.938C380.856 275.812 381.181 275.749 381.51 275.75H450.66C450.989 275.749 451.314 275.812 451.618 275.938C451.922 276.063 452.198 276.247 452.431 276.479C452.663 276.712 452.847 276.988 452.972 277.292C453.098 277.596 453.161 277.921 453.16 278.25V370.25C453.16 370.913 452.897 371.549 452.428 372.018C451.959 372.487 451.323 372.75 450.66 372.75V372.75ZM384.01 367.75H448.16V280.75H384.01V367.75Z",
    fill: "#66142E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M416.08 372.43C415.417 372.43 414.781 372.167 414.312 371.698C413.843 371.229 413.58 370.593 413.58 369.93V278.51C413.58 277.847 413.843 277.211 414.312 276.742C414.781 276.273 415.417 276.01 416.08 276.01C416.743 276.01 417.379 276.273 417.848 276.742C418.317 277.211 418.58 277.847 418.58 278.51V369.93C418.58 370.593 418.317 371.229 417.848 371.698C417.379 372.167 416.743 372.43 416.08 372.43Z",
    fill: "#66142E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M450.15 326.75H382.02C381.357 326.75 380.721 326.487 380.252 326.018C379.783 325.549 379.52 324.913 379.52 324.25C379.52 323.587 379.783 322.951 380.252 322.482C380.721 322.013 381.357 321.75 382.02 321.75H450.15C450.813 321.75 451.449 322.013 451.918 322.482C452.387 322.951 452.65 323.587 452.65 324.25C452.65 324.913 452.387 325.549 451.918 326.018C451.449 326.487 450.813 326.75 450.15 326.75Z",
    fill: "#66142E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M610.67 354.96C609.82 337.78 615.35 325.2 631.15 325.29V323.43H605.31V355.09L610.67 354.96Z",
    fill: "#85D0EF"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M654.33 387.05H606.68C606.017 387.05 605.381 386.787 604.912 386.318C604.443 385.849 604.18 385.213 604.18 384.55V322.89C604.18 322.227 604.443 321.591 604.912 321.122C605.381 320.653 606.017 320.39 606.68 320.39H654.33C654.993 320.39 655.629 320.653 656.098 321.122C656.567 321.591 656.83 322.227 656.83 322.89V384.55C656.83 385.213 656.567 385.849 656.098 386.318C655.629 386.787 654.993 387.05 654.33 387.05V387.05ZM609.18 382.05H651.82V325.43H609.17L609.18 382.05Z",
    fill: "#66142E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M631.15 386.66C629.77 386.66 628.65 386.4 628.65 385.02V322.02C628.65 320.64 629.77 320.71 631.15 320.71C632.53 320.71 633.65 320.64 633.65 322.02V385.02C633.65 386.43 632.54 386.66 631.15 386.66Z",
    fill: "#66142E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M653.82 356.43H606.82C606.157 356.43 605.521 356.167 605.052 355.698C604.583 355.229 604.32 354.593 604.32 353.93C604.32 353.267 604.583 352.631 605.052 352.162C605.521 351.693 606.157 351.43 606.82 351.43H653.82C654.483 351.43 655.119 351.693 655.588 352.162C656.057 352.631 656.32 353.267 656.32 353.93C656.32 354.593 656.057 355.229 655.588 355.698C655.119 356.167 654.483 356.43 653.82 356.43Z",
    fill: "#66142E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M779.35 387.05H731.7C731.037 387.05 730.401 386.787 729.932 386.318C729.463 385.849 729.2 385.213 729.2 384.55V322.89C729.2 322.227 729.463 321.591 729.932 321.122C730.401 320.653 731.037 320.39 731.7 320.39H779.35C780.013 320.39 780.649 320.653 781.118 321.122C781.587 321.591 781.85 322.227 781.85 322.89V384.55C781.85 385.213 781.587 385.849 781.118 386.318C780.649 386.787 780.013 387.05 779.35 387.05ZM734.2 382.05H776.82V325.43H734.17L734.2 382.05Z",
    fill: "#66142E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M756.18 386.58C754.8 386.58 753.68 386.4 753.68 385.02V322.02C753.68 320.64 754.8 320.96 756.18 320.96C757.56 320.96 758.68 320.64 758.68 322.02V385.02C758.68 386.43 757.56 386.58 756.18 386.58Z",
    fill: "#66142E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M778.82 356.43H731.82C731.157 356.43 730.521 356.167 730.052 355.698C729.583 355.229 729.32 354.593 729.32 353.93C729.32 353.267 729.583 352.631 730.052 352.162C730.521 351.693 731.157 351.43 731.82 351.43H778.82C779.483 351.43 780.119 351.693 780.588 352.162C781.057 352.631 781.32 353.267 781.32 353.93C781.32 354.593 781.057 355.229 780.588 355.698C780.119 356.167 779.483 356.43 778.82 356.43Z",
    fill: "#66142E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M246.55 137.72C246.01 125.34 249.55 116.28 259.55 116.35V115.03H243.15V137.83L246.55 137.72Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M264.57 137.72C264.03 125.34 267.57 116.28 277.57 116.35V115.03H261.16V137.83L264.57 137.72Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M246.55 161.17C246.01 148.79 249.55 139.73 259.55 139.8V138.48H243.15V161.28L246.55 161.17Z",
    fill: "#85D0EF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M264.57 161.17C264.03 148.79 267.57 139.73 277.57 139.8V138.48H261.16V161.28L264.57 161.17Z",
    fill: "#85D0EF"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M278.92 162.09H243.41C242.747 162.09 242.111 161.827 241.642 161.358C241.173 160.889 240.91 160.253 240.91 159.59V116.08C240.91 115.417 241.173 114.781 241.642 114.312C242.111 113.843 242.747 113.58 243.41 113.58H278.92C279.583 113.58 280.219 113.843 280.688 114.312C281.157 114.781 281.42 115.417 281.42 116.08V159.59C281.42 160.253 281.157 160.889 280.688 161.358C280.219 161.827 279.583 162.09 278.92 162.09V162.09ZM245.92 157.09H276.43V118.58H245.92V157.09Z",
    fill: "#66142E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M277.54 140.33H244.82C244.157 140.33 243.521 140.067 243.052 139.598C242.583 139.129 242.32 138.493 242.32 137.83C242.32 137.167 242.583 136.531 243.052 136.062C243.521 135.593 244.157 135.33 244.82 135.33H277.58C278.243 135.33 278.879 135.593 279.348 136.062C279.817 136.531 280.08 137.167 280.08 137.83C280.08 138.493 279.817 139.129 279.348 139.598C278.879 140.067 278.243 140.33 277.58 140.33H277.54Z",
    fill: "#66142E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M261.16 161.82C260.497 161.82 259.861 161.557 259.392 161.088C258.923 160.619 258.66 159.983 258.66 159.32V116.32C258.66 115.657 258.923 115.021 259.392 114.552C259.861 114.083 260.497 113.82 261.16 113.82C261.823 113.82 262.459 114.083 262.928 114.552C263.397 115.021 263.66 115.657 263.66 116.32V159.32C263.661 159.649 263.598 159.974 263.472 160.278C263.347 160.582 263.163 160.858 262.931 161.091C262.698 161.323 262.422 161.507 262.118 161.632C261.814 161.758 261.489 161.821 261.16 161.82Z",
    fill: "#66142E"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M861.1 443.61H65.57C64.907 443.61 64.271 443.347 63.8022 442.878C63.3334 442.409 63.07 441.773 63.07 441.11V427C63.0687 426.671 63.1324 426.346 63.2575 426.042C63.3827 425.738 63.5669 425.462 63.7993 425.229C64.0317 424.997 64.3079 424.813 64.6118 424.688C64.9157 424.562 65.2414 424.499 65.57 424.5H861.1C861.429 424.499 861.754 424.562 862.058 424.688C862.362 424.813 862.638 424.997 862.871 425.229C863.103 425.462 863.287 425.738 863.412 426.042C863.537 426.346 863.601 426.671 863.6 427V441.11C863.6 441.773 863.337 442.409 862.868 442.878C862.399 443.347 861.763 443.61 861.1 443.61V443.61ZM68.1001 438.61H858.63V429.5H68.07L68.1001 438.61Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8201 236.35C61.3545 236.35 60.8978 236.222 60.5001 235.98L37.9002 221.98C37.5789 221.778 37.3073 221.506 37.1063 221.184C36.9052 220.862 36.7797 220.499 36.7393 220.122C36.6989 219.745 36.7446 219.363 36.8729 219.006C37.0012 218.649 37.2087 218.325 37.48 218.06L259.37 2.24004C259.807 1.81385 260.385 1.56224 260.995 1.53276C261.604 1.50329 262.204 1.69796 262.68 2.08L417.38 125.76C417.899 126.174 418.232 126.777 418.306 127.436C418.38 128.095 418.189 128.756 417.775 129.275C417.361 129.793 416.759 130.126 416.099 130.2C415.44 130.275 414.779 130.084 414.26 129.67L261.26 7.36003L43.2601 219.36L61.47 230.67L259.36 36.43C259.79 36.0086 260.357 35.7564 260.958 35.7197C261.559 35.6829 262.152 35.8642 262.63 36.23L400.13 141.09C400.393 141.287 400.614 141.534 400.781 141.816C400.949 142.099 401.059 142.411 401.105 142.736C401.151 143.061 401.133 143.392 401.052 143.71C400.97 144.028 400.827 144.327 400.63 144.59C400.433 144.853 400.186 145.074 399.904 145.241C399.621 145.408 399.309 145.518 398.984 145.565C398.659 145.611 398.328 145.593 398.01 145.512C397.692 145.43 397.393 145.287 397.13 145.09L261.32 41.48L63.5701 235.63C63.3404 235.86 63.0675 236.041 62.7672 236.165C62.4668 236.289 62.1449 236.351 61.8201 236.35Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M480.16 429.5H78.2599C77.5969 429.5 76.961 429.237 76.4921 428.768C76.0233 428.299 75.7599 427.663 75.7599 427V219.33C75.7599 218.667 76.0233 218.031 76.4921 217.562C76.961 217.093 77.5969 216.83 78.2599 216.83C78.923 216.83 79.5589 217.093 80.0278 217.562C80.4966 218.031 80.7599 218.667 80.7599 219.33V424.5H480.16C480.823 424.5 481.459 424.763 481.928 425.232C482.397 425.701 482.66 426.337 482.66 427C482.66 427.663 482.397 428.299 481.928 428.768C481.459 429.237 480.823 429.5 480.16 429.5V429.5Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M260.65 292.83C260.183 292.828 259.726 292.696 259.33 292.45L243.33 282.52C242.999 282.318 242.721 282.04 242.517 281.71C242.314 281.38 242.192 281.006 242.16 280.62C242.124 280.232 242.18 279.841 242.322 279.478C242.465 279.115 242.69 278.79 242.98 278.53L414.15 125.82C414.606 125.41 415.197 125.182 415.81 125.182C416.423 125.182 417.014 125.41 417.47 125.82L588.62 278.53C588.913 278.788 589.14 279.111 589.286 279.474C589.431 279.836 589.489 280.227 589.456 280.616C589.423 281.004 589.299 281.38 589.095 281.712C588.891 282.045 588.612 282.325 588.28 282.53L572.28 292.46C571.82 292.75 571.278 292.882 570.736 292.835C570.195 292.788 569.683 292.565 569.28 292.2L568.58 291.57L415.82 155.22L262.31 292.22C261.85 292.62 261.259 292.837 260.65 292.83V292.83ZM248.82 280.04L260.39 287.22L414.17 150C414.627 149.589 415.22 149.361 415.835 149.361C416.45 149.361 417.043 149.589 417.5 150L571.26 287.22L582.82 280.04L415.82 131.04L248.82 280.04Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M556.67 429.5H272.28C271.617 429.5 270.981 429.237 270.512 428.768C270.043 428.299 269.78 427.663 269.78 427V280C269.78 279.337 270.043 278.701 270.512 278.232C270.981 277.763 271.617 277.5 272.28 277.5C272.943 277.5 273.579 277.763 274.048 278.232C274.517 278.701 274.78 279.337 274.78 280V424.45H554.17V277.56C554.17 276.897 554.433 276.261 554.902 275.792C555.371 275.323 556.007 275.06 556.67 275.06C557.333 275.06 557.969 275.323 558.438 275.792C558.907 276.261 559.17 276.897 559.17 277.56V427C559.17 427.663 558.907 428.299 558.438 428.768C557.969 429.237 557.333 429.5 556.67 429.5Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M490 196.36C489.493 196.358 488.999 196.202 488.583 195.913C488.167 195.623 487.848 195.214 487.67 194.74L444.96 82.2499H355.82C355.157 82.2499 354.521 81.9866 354.052 81.5178C353.583 81.0489 353.32 80.413 353.32 79.7499C353.32 79.0869 353.583 78.4511 354.052 77.9822C354.521 77.5134 355.157 77.2499 355.82 77.2499H446.65C447.156 77.2498 447.65 77.4038 448.066 77.6915C448.482 77.9791 448.801 78.3867 448.98 78.86L492.3 192.97C492.534 193.591 492.513 194.279 492.242 194.884C491.97 195.489 491.47 195.963 490.85 196.2C490.577 196.298 490.29 196.352 490 196.36V196.36Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8199 197.43C64.5192 197.431 64.221 197.377 63.94 197.27C63.6327 197.154 63.3511 196.979 63.1114 196.755C62.8717 196.531 62.6786 196.261 62.5431 195.962C62.4075 195.663 62.3322 195.341 62.3214 195.013C62.3105 194.684 62.3643 194.357 62.4798 194.05L105.8 78.8501C105.976 78.3725 106.296 77.9608 106.714 77.671C107.133 77.3812 107.631 77.2272 108.14 77.2301H183.26C183.923 77.2301 184.559 77.4934 185.028 77.9623C185.497 78.4311 185.76 79.067 185.76 79.7301C185.76 80.3931 185.497 81.0289 185.028 81.4978C184.559 81.9666 183.923 82.2301 183.26 82.2301H109.82L67.1099 195.81C66.9329 196.277 66.6202 196.681 66.2122 196.97C65.8043 197.258 65.3195 197.419 64.8199 197.43Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M876.51 282.55H586.97C586.307 282.55 585.671 282.287 585.202 281.818C584.733 281.349 584.47 280.713 584.47 280.05C584.47 279.387 584.733 278.751 585.202 278.282C585.671 277.813 586.307 277.55 586.97 277.55H872.21L805.74 160.81H476.51C475.847 160.81 475.211 160.547 474.742 160.078C474.273 159.609 474.01 158.973 474.01 158.31C474.01 157.647 474.273 157.011 474.742 156.542C475.211 156.073 475.847 155.81 476.51 155.81H807.19C807.631 155.809 808.064 155.925 808.445 156.147C808.827 156.368 809.142 156.687 809.36 157.07L878.69 278.81C878.908 279.191 879.021 279.622 879.019 280.061C879.017 280.5 878.9 280.93 878.679 281.309C878.458 281.688 878.141 282.002 877.761 282.22C877.38 282.438 876.949 282.552 876.51 282.55V282.55Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M848.4 429.5H556.67C556.007 429.5 555.371 429.237 554.902 428.768C554.433 428.299 554.17 427.663 554.17 427C554.17 426.337 554.433 425.701 554.902 425.232C555.371 424.763 556.007 424.5 556.67 424.5H845.9V280.05C845.9 279.387 846.163 278.751 846.632 278.282C847.101 277.813 847.737 277.55 848.4 277.55C849.063 277.55 849.699 277.813 850.168 278.282C850.637 278.751 850.9 279.387 850.9 280.05V427.05C850.89 427.705 850.621 428.33 850.153 428.788C849.685 429.247 849.055 429.503 848.4 429.5Z",
    fill: "#281A1F",
    stroke: "#281A1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M366.06 82.2499H357.36C356.697 82.2499 356.061 81.9866 355.592 81.5178C355.123 81.0489 354.86 80.413 354.86 79.7499V63.35C354.86 62.687 355.123 62.0511 355.592 61.5822C356.061 61.1134 356.697 60.85 357.36 60.85H366.06C366.723 60.85 367.359 61.1134 367.828 61.5822C368.297 62.0511 368.56 62.687 368.56 63.35V79.7499C368.56 80.413 368.297 81.0489 367.828 81.5178C367.359 81.9866 366.723 82.2499 366.06 82.2499V82.2499ZM359.86 77.2499H363.56V65.85H359.82L359.86 77.2499Z",
    fill: "#281A1F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M373.82 65.85H349.54C348.877 65.85 348.241 65.5866 347.772 65.1177C347.303 64.6489 347.04 64.0131 347.04 63.35V55.67C347.04 55.0069 347.303 54.3711 347.772 53.9023C348.241 53.4334 348.877 53.17 349.54 53.17H373.82C374.483 53.17 375.119 53.4334 375.588 53.9023C376.057 54.3711 376.32 55.0069 376.32 55.67V63.35C376.32 64.0131 376.057 64.6489 375.588 65.1177C375.119 65.5866 374.483 65.85 373.82 65.85ZM352.04 60.85H371.32V58.17H352.04V60.85Z",
    fill: "#281A1F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M366.06 58.17H357.36C356.697 58.17 356.061 57.9066 355.592 57.4378C355.123 56.969 354.86 56.333 354.86 55.67V45.82C354.86 45.157 355.123 44.521 355.592 44.0522C356.061 43.5833 356.697 43.32 357.36 43.32H366.06C366.723 43.32 367.359 43.5833 367.828 44.0522C368.297 44.521 368.56 45.157 368.56 45.82V55.67C368.56 56.333 368.297 56.969 367.828 57.4378C367.359 57.9066 366.723 58.17 366.06 58.17V58.17ZM359.86 53.17H363.56V48.32H359.82L359.86 53.17Z",
    fill: "#281A1F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M375.29 48.32H348.13C345.938 48.3174 343.835 47.4452 342.285 45.8948C340.735 44.3445 339.863 42.2425 339.86 40.05V39.71C339.863 37.5175 340.735 35.4155 342.285 33.8652C343.835 32.3148 345.938 31.4426 348.13 31.44H375.29C377.483 31.4426 379.586 32.3145 381.138 33.8646C382.69 35.4146 383.565 37.5166 383.57 39.71V40.05C383.565 42.2434 382.69 44.3454 381.138 45.8954C379.586 47.4455 377.483 48.3174 375.29 48.32V48.32ZM348.13 36.43C347.263 36.43 346.431 36.7745 345.818 37.3878C345.205 38.001 344.86 38.8328 344.86 39.7V40.04C344.86 40.9072 345.205 41.739 345.818 42.3522C346.431 42.9655 347.263 43.31 348.13 43.31H375.29C376.158 43.31 376.991 42.9658 377.606 42.3528C378.221 41.7399 378.567 40.9082 378.57 40.04V39.7C378.567 38.8318 378.221 38.0001 377.606 37.3871C376.991 36.7742 376.158 36.43 375.29 36.43H348.13Z",
    fill: "#281A1F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M124.82 417.5H211.3V244.09H124.82V417.5ZM131.82 330.79V253.59C131.819 253.261 131.882 252.936 132.008 252.632C132.133 252.328 132.317 252.052 132.549 251.819C132.782 251.587 133.058 251.403 133.362 251.278C133.666 251.152 133.991 251.089 134.32 251.09H201.82C202.149 251.089 202.474 251.152 202.778 251.278C203.082 251.403 203.358 251.587 203.591 251.819C203.823 252.052 204.007 252.328 204.133 252.632C204.258 252.936 204.321 253.261 204.32 253.59V408C204.32 408.663 204.057 409.299 203.588 409.768C203.119 410.237 202.483 410.5 201.82 410.5H134.34C133.677 410.5 133.041 410.237 132.572 409.768C132.103 409.299 131.84 408.663 131.84 408L131.82 330.79Z",
    fill: "#B55232"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M199.29 328.29V256.09H136.82V328.29H199.29ZM180.62 318.59H192.34C193.003 318.59 193.639 318.853 194.108 319.322C194.577 319.791 194.84 320.427 194.84 321.09C194.84 321.753 194.577 322.389 194.108 322.858C193.639 323.327 193.003 323.59 192.34 323.59H180.62C179.957 323.59 179.321 323.327 178.852 322.858C178.383 322.389 178.12 321.753 178.12 321.09C178.12 320.427 178.383 319.791 178.852 319.322C179.321 318.853 179.957 318.59 180.62 318.59V318.59Z",
    fill: "#B55232"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M199.29 333.29H136.81V405.49H199.29V333.29Z",
    fill: "#B55232"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M213.93 241.78H208.2V420.15H213.93V241.78Z",
    fill: "#B55232"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M180.11 255.66C180.11 255.66 195.65 255.94 196.22 265.55C196.79 275.16 196.22 330.79 196.22 330.79H202.72V253.96L180.11 255.66Z",
    fill: "#B55232"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M180.11 332.67C180.11 332.67 195.65 332.96 196.22 342.56C196.79 352.16 196.22 407.81 196.22 407.81H202.72V330.98L180.11 332.67Z",
    fill: "#B55232"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M125.39 239.08H115.62C114.267 239.08 113.17 240.177 113.17 241.53V417.7C113.17 419.053 114.267 420.15 115.62 420.15H125.39C126.743 420.15 127.84 419.053 127.84 417.7V241.53C127.84 240.177 126.743 239.08 125.39 239.08Z",
    fill: "#E5D3BD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.12 289.26C152.65 289.26 153.08 287.156 153.08 284.56C153.08 281.964 152.65 279.86 152.12 279.86C151.59 279.86 151.16 281.964 151.16 284.56C151.16 287.156 151.59 289.26 152.12 289.26Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M152.26 324.89C151.34 324.89 150.6 321.7 150.6 317.76C150.6 313.82 151.34 310.62 152.26 310.62C153.18 310.62 153.91 313.81 153.91 317.76C153.91 321.71 153.17 324.89 152.26 324.89Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M152.17 380.5C153.772 380.5 155.07 370.4 155.07 357.94C155.07 345.48 153.772 335.38 152.17 335.38C150.568 335.38 149.27 345.48 149.27 357.94C149.27 370.4 150.568 380.5 152.17 380.5Z",
    fill: "white"
  })))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M213.82 422.5H122.34C121.677 422.5 121.041 422.237 120.572 421.768C120.103 421.299 119.84 420.663 119.84 420V241.59C119.839 241.261 119.902 240.936 120.028 240.632C120.153 240.328 120.337 240.052 120.569 239.819C120.802 239.587 121.078 239.403 121.382 239.278C121.686 239.153 122.011 239.089 122.34 239.09H213.82C214.149 239.089 214.474 239.153 214.778 239.278C215.082 239.403 215.358 239.587 215.591 239.819C215.823 240.052 216.007 240.328 216.133 240.632C216.258 240.936 216.321 241.261 216.32 241.59V420C216.32 420.663 216.057 421.299 215.588 421.768C215.119 422.237 214.483 422.5 213.82 422.5V422.5ZM124.82 417.5H211.3V244.09H124.82V417.5Z",
    fill: "#66142E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M201.82 410.5H134.34C133.677 410.5 133.041 410.237 132.572 409.768C132.103 409.299 131.84 408.663 131.84 408V253.59C131.839 253.261 131.902 252.936 132.028 252.632C132.153 252.328 132.337 252.052 132.569 251.819C132.802 251.587 133.078 251.403 133.382 251.278C133.686 251.153 134.011 251.089 134.34 251.09H201.82C202.149 251.089 202.474 251.153 202.778 251.278C203.082 251.403 203.358 251.587 203.591 251.819C203.823 252.052 204.007 252.328 204.133 252.632C204.258 252.936 204.321 253.261 204.32 253.59V408C204.32 408.663 204.057 409.299 203.588 409.768C203.119 410.237 202.483 410.5 201.82 410.5V410.5ZM136.82 405.5H199.3V256.09H136.82V405.5Z",
    fill: "#66142E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M201.82 410.5H134.34C133.677 410.5 133.041 410.237 132.572 409.768C132.103 409.299 131.84 408.663 131.84 408V330.79C131.84 330.127 132.103 329.491 132.572 329.022C133.041 328.553 133.677 328.29 134.34 328.29H201.82C202.483 328.29 203.119 328.553 203.588 329.022C204.057 329.491 204.32 330.127 204.32 330.79V408C204.32 408.663 204.057 409.299 203.588 409.768C203.119 410.237 202.483 410.5 201.82 410.5V410.5ZM136.82 405.5H199.3V333.29H136.82V405.5Z",
    fill: "#66142E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M192.34 323.59H180.62C179.957 323.59 179.321 323.327 178.852 322.858C178.383 322.389 178.12 321.753 178.12 321.09C178.12 320.427 178.383 319.791 178.852 319.322C179.321 318.853 179.957 318.59 180.62 318.59H192.34C193.003 318.59 193.639 318.853 194.108 319.322C194.577 319.791 194.84 320.427 194.84 321.09C194.84 321.753 194.577 322.389 194.108 322.858C193.639 323.327 193.003 323.59 192.34 323.59Z",
    fill: "#66142E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M344.92 4.42999C344.947 4.42999 344.972 4.41945 344.991 4.4007C345.009 4.38194 345.02 4.35654 345.02 4.33002C345.02 4.3035 345.009 4.27809 344.991 4.25934C344.972 4.24058 344.947 4.23004 344.92 4.23004C344.894 4.23004 344.868 4.24058 344.849 4.25934C344.831 4.27809 344.82 4.3035 344.82 4.33002C344.82 4.35654 344.831 4.38194 344.849 4.4007C344.868 4.41945 344.894 4.42999 344.92 4.42999Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M374.03 12.03C374.057 12.03 374.082 12.0194 374.101 12.0007C374.12 11.9819 374.13 11.9565 374.13 11.93C374.13 11.9035 374.12 11.8781 374.101 11.8593C374.082 11.8406 374.057 11.83 374.03 11.83C373.91 11.83 373.9 12.03 374.03 12.03Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.e67bf885c6ab7dd4c8798d3e0e39cec1.svg";
export { ForwardRef as ReactComponent };